import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

class DocumentReview extends React.Component {
  docReviewed = () => {
    this.props.onSubmit(this.props.doc.getId());
  };

  render() {
    const { intl, show, close, onSubmitParent, doc, formStatus } = this.props;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.review} {doc ? doc.getName() : null}
          </Modal.Title>
        </Modal.Header>
        {doc ? (
          <Modal.Body>
            <p>{messages.please_check_document_check_expiration_date}</p>

            <div class="text-right m-t-15">
              <Button bsSize="lg" disabled={formStatus.pending} bsStyle="primary" onClick={this.docReviewed}>
                <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin ' : 'fal fa-save ')} />{' '}
                {messages.i_reviewed_the_document}
              </Button>
            </div>
          </Modal.Body>
        ) : null}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.documentReview,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: docId => {
      formStatusDispatchHelper('documentReview', '/api/docs/' + docId + '/review.json', {}, 'put', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DocumentReview)
  )
);
